module.exports = __webpack_public_path__ + "img/vedio.b0d4a30c.png";